/* Immediate, reversible feedback for Noom direct checkout buttons. */
(() => {
  'use strict';
  if (window.HMCheckoutFeedback) return;

  const active = new WeakMap();
  const restoreAttribute = (node, name, value) => {
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
  };

  window.HMCheckoutFeedback = {
    set(productForm, busy) {
      if (!productForm) return;
      const previous = active.get(productForm);
      if (!busy) {
        if (!previous) return;
        previous.observer?.disconnect();
        previous.buttons.forEach(({ button, labels, ariaLabel, ariaDisabled }) => {
          labels.forEach(({ label, children }) => label.replaceChildren(...children));
          restoreAttribute(button, 'aria-label', ariaLabel);
          button.removeAttribute('aria-busy');
          if (button !== previous.main) restoreAttribute(button, 'aria-disabled', ariaDisabled);
        });
        if (previous.price && !previous.priceWasHidden) previous.price.classList.remove('hidden');
        previous.status.remove();
        active.delete(productForm);
        // A sticky purchase can fail while the form's alert is above the screen.
        // Reveal the existing alert instead of leaving the customer at an idle CTA.
        const error = productForm.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (previous.revealOffscreenError && error?.textContent.trim()) {
          const rect = error.getBoundingClientRect();
          if (rect.bottom <= 0 || rect.top >= window.innerHeight) error.scrollIntoView({ behavior: 'instant', block: 'center' });
          if (!error.hasAttribute('tabindex')) {
            error.setAttribute('tabindex', '-1');
            error.addEventListener('blur', () => error.removeAttribute('tabindex'), { once: true });
          }
          error.focus({ preventScroll: true });
        }
        return;
      }
      if (previous || productForm.dataset.directCheckout !== 'true') return;

      const main = productForm.querySelector('button[type="submit"]');
      if (!main) return;
      const labelsOf = button => Array.from(button.querySelectorAll(button.matches('[data-elora-sbar-btn]')
        ? '.sbar__t, .sbar__tm' : button.matches('.pdp__atc') ? ':scope > span:first-child' : '.button-text'));
      const buttons = [main, ...document.querySelectorAll('#stickyAddToCart button[onclick*="addToCartSticky"], [data-elora-sbar-btn]')]
        .map(button => ({ button, labels: labelsOf(button) }))
        .filter(entry => entry.labels.length)
        .map(({ button, labels }) => ({ button, labels: labels.map(label => ({ label, children: Array.from(label.childNodes) })),
          ariaLabel: button.getAttribute('aria-label'), ariaDisabled: button.getAttribute('aria-disabled') }));
      if (!buttons.length) return;

      const message = productForm.dataset.checkoutLoading || 'Przechodzę do kasy…';
      const labelMessage = (button, label) => label.matches('.sbar__tm')
        ? button.dataset.checkoutLoadingMobile || message : message;
      const price = main.querySelector('.pdp__atcp');
      const status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      productForm.append(status);
      const mainRect = main.getBoundingClientRect?.();
      const state = { main, buttons, price, priceWasHidden: price?.classList.contains('hidden'), status,
        revealOffscreenError: mainRect && (mainRect.bottom <= 0 || mainRect.top >= window.innerHeight) };
      active.set(productForm, state);
      if (price) price.classList.add('hidden');
      buttons.forEach(({ button, labels }) => {
        labels.forEach(({ label }) => { label.textContent = labelMessage(button, label); });
        button.setAttribute('aria-label', message);
        button.setAttribute('aria-busy', 'true');
        if (button !== main) button.setAttribute('aria-disabled', 'true');
      });
      status.textContent = message;

      // The basic PDP updates its label when bundle selection changes. Keep the
      // checkout message visible until the operation ends.
      if (typeof MutationObserver !== 'undefined') {
        state.observer = new MutationObserver(() => {
          buttons.forEach(({ button, labels }) => labels.forEach(({ label }) => {
            const text = labelMessage(button, label);
            if (label.textContent !== text) label.textContent = text;
          }));
        });
        buttons.forEach(({ labels }) => labels.forEach(({ label }) => state.observer.observe(label, { childList: true, characterData: true, subtree: true })));
      }
    },
  };
})();
